import { Flex, Form } from "antd";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useEffect, useState } from "react";

import { changeBidBankAccount } from "services";
import { useStores } from "stores";
import { CustomButton, DefaultSelect } from "ui";
import { parseErrorMessage, renderBankOptions } from "utils";
import { _isRequired } from "utils/form/simple-validation";

interface FieldType {
  accountId: string;
}

export const ChangeBankAccountModal = observer((props: { bankAccountId?: string }) => {
  const { actionModals, bankAccountsStore, user, bidCard } = useStores();
  const { openNotification } = useNotificationContext();
  const { bankAccountId } = props;

  const companyId = user.userInfo?.company_id;
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    if (companyId) {
      bankAccountsStore.fetchBankAccounts(companyId).then((res) => {
        if (res?.length && res.length > 0 && res.some((item) => item.id === bankAccountId)) {
          form.setFieldsValue({
            accountId: bankAccountId,
          });
        }
      });
    }
  }, [bankAccountsStore, companyId, form, bankAccountId]);

  const changeBankAccountHandler = async () => {
    setLoading(true);
    const values: FieldType = form.getFieldsValue();

    await changeBidBankAccount({ id: bidCard.bid.id }, { accountId: values.accountId })
      .then(() => {
        setTimeout(() => bidCard.updateCardById(bidCard.bid.id), 1500);
        handleCloseModal();
        openNotification({
          message: "Реквизиты сохранены",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
      })
      .catch((e) => {
        openNotification({
          type: NOTIFICATION_TYPE_ENUM.ERROR,
          description: parseErrorMessage(e),
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  return (
    <Flex vertical gap="large">
      <Form
        form={form}
        name="changeBankAccount"
        initialValues={{
          companyFee: "",
        }}
        onFinish={() => changeBankAccountHandler()}
      >
        <Form.Item
          rules={[_isRequired("Банковские реквизиты обязательны для ввода")]}
          name="accountId"
          className="full-width"
          validateDebounce={FORM_VALIDATION_DEBOUNCE}
          children={
            <DefaultSelect disabled={loading} size="large" placeholder="Банковские реквизиты">
              {renderBankOptions(bankAccountsStore.bankAccounts)}
            </DefaultSelect>
          }
        />
        <Form.Item>
          <Flex gap="large">
            <CustomButton htmlType="submit" disabled={loading} loading={loading}>
              Сохранить
            </CustomButton>
            <CustomButton
              htmlType="button"
              disabled={loading}
              loading={loading}
              type="default"
              onClick={handleCloseModal}
            >
              Отменить
            </CustomButton>
          </Flex>
        </Form.Item>
      </Form>
    </Flex>
  );
});
